import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { DataService } from 'src/app/services/data.service';
import { FlightService } from 'src/app/services/flight.service';
import {CarrierCodeService} from '../../../services/carrier-code.service';
import {CartService} from '../../../services/cart.service';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import { P } from '@angular/cdk/keycodes';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-insurance-modify-cart',
  templateUrl: './insurance-modify-cart.component.html',
  styleUrls: ['./insurance-modify-cart.component.css']
})
export class InsuranceModifyCartComponent {
// showCartInformation:boolean=false
  // showItinerary:boolean=false
  // showClientInformation:boolean=false
  
  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);
  // Default:any
  //
  // showDataEntity:boolean=false;
  // search:any={searchText:""}
  // showDataEntityPopup:boolean=false
  // DataEntityRegFg!:FormGroup
  // columnsDataEntityDisplay: string[] = ['expand','Name','isEnabled'];
  // expandedElement!: any | null;
  // totalElements:any=0
  // action:any
  // entityList:any;
  // DataEntity:any=[]
  // creationDate:any
  // id:any
  showGSTPopup:boolean=false
  insuranceData:any
  flightList:any
  carrierCode:any=[]
  flights:any
returnFlights:any
thirdFlights:any
fourthFlights:any
returnLastFlight:any
thirdLastFlight:any
fourthLastFlight:any
lastflight:any
clientName:any
bookedBy:any
cartUuid:any
comment:any
showButtons:boolean=true
amendCartList:any=[]
showAmendProcess:any=false
loginUserType:any
  constructor(private sanitizer: DomSanitizer,private SettingsService:SettingsService,private CarrierCodeService:CarrierCodeService,private router:Router,private location:Location,private fb : FormBuilder, private  toastMsgService : ToastmsgService,
    private DataEntityService:ReportingConfigService,private FlightService:FlightService,private DialogService:DialogService,
    private StaticdataService:StaticdataService,private route:ActivatedRoute,private DataService:DataService,private CartService:CartService,private UserService:UserService){
      this.getFlightList();
      this.carrierCode=this.CarrierCodeService.carrierCode()
      this.loginUserType=sessionStorage.getItem('loginUserType')
    this.loginUserType=this.loginUserType.toUpperCase()
      this.dataFields()
    let path:any
 path=this.route?.snapshot
 let urlPath:any
 urlPath=path?.routeConfig?.path
 if(urlPath==='view-cart'){
  this.showButtons=false
 }
      this.route.queryParams.subscribe(params => {
        let data:any
        data=params
        // console.log(params)
      if(data?.id){
        this.cartUuid=data?.id
        if( this.cartUuid){
        this.firstCallOrder(data?.id)}
        this.GetAmend(data?.id)
        this.getSancharWhatsApp(data?.id)
        this.getSancharEmailApp(data?.id)

      }})
      this.DataService.portMessage.subscribe((message:any) =>{


       
      
      })


    }
   

    nextPage(event:PageEvent) {
    
      let page:any = {};
      page['page'] = event.pageIndex.toString();
      page['size'] = event.pageSize.toString();
      
      //this.getAllUser(page)
    
    }
    GstRegFg!:FormGroup
  dataFields(){
    this.GstRegFg=this.fb.group({
      'name':[''],
        // "address":[''],
        // "phone":[''],
        // "email":['',[Validators.email]],
        // "state":[''],
        // "gstType":[''],
        // "gstName":[''],
        // "entityGST":[''],
        // "gstAccountCode":[''],
        // "entityName":['',[Validators.required]],
        // "accountCode":['',[Validators.required]],
        // "isEnabled":['']
        
    });
    
  }
  closePopup() {
    this.showAmendProcess=false
    this.showGSTPopup=false
    this.showAmend=false
    this.dataFields()
  }
  openGstDetail(){
    this.showGSTPopup=true

  }
  AddDataEntity(){
    

    //   this.DataEntityService.saveEntity(this.DataEntityRegFg.value,this.id)
    //   .subscribe({
    //     next : (res) => {
    //       if(res.status==200 || res.status==201) {
    //         this.toastMsgService.setMsg({msg : "Billing Entity Added Successfully!",msgTitle : "Success", msgType : "I"});
           
    //        this.showDataEntityPopup=false
    //        this.dataFields();
    //        this.dataEntitylist()

    //       } else {
    //         const body : any = res.body;
    //         this.registerDataEntityErrorMsg(res.status,body?.result);
    //       } 
  
    //     },error : (err) => {
  
    //       this.registerDataEntityErrorMsg(err.status,err.error);
    //     }
    //   }
    // )
  }
  
  registerDataEntityErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Billing Entity",msgTitle : "Warning", msgType : "W"});
    } else {
  
      this.toastMsgService.setMsg({msg : "Failed to save Billing Entity",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
  
  backClick(){
    window.close();

    // window.location.href = "/app/manage-carts"
    }
      rowdataEntityClick(element:any){
       
        // this.action="updateEntity"
        // this.showDataEntityPopup=true
        // this.DataEntityRegFg=this.fb.group({
        //   "address":[element?.address],
        //   "phone":[element?.phone],
        //   "email":[element?.email,[Validators.email]],
        //   "state":[element?.state],
        //   "gstType":[element?.gstType],
        //   "gstName":[element?.gstName],
        //   "entityGST":[element?.entityGST],
        //   "gstAccountCode":[element?.gstAccountCode],
        //   "entityName":[element?.entityName,[Validators.required]],
        //   "accountCode":[element?.accountCode,[Validators.required]],
        //   "isEnabled":[element?.isEnabled.toString()],
        //   "entityId":[element?.entityId]
        // });
       
      }
      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }
     
     
     
      stateData:any
stateList(){
  this.StaticdataService
  .getStates()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.stateData=data
     console.log(this.stateData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

getFlightList(){
   
  this.FlightService
  .getFlightList()
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
       this.flightList=data
   
      } else {    
      } 
    },error : (err) => {

      
    }
  }
)
}
converter(item:any){
  const totalMinutes = item ;
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  item=`${hours}h ${remainingMinutes}m`
  return item
}
fligthNameFilter(item:any){
if(item){
let flightName:any=[]
flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
if(flightName.length===0){
 return item

}else{
 flightName =flightName[0].flightName
 return flightName
}}else{
return item
}
}
cityFilter(item:any){
  

  if(item && this.flightList){
   

    item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

  item=item[0]?.city

return item}else{
  return item
}
}
airPortFilter(item:any){
  
  if(item && this.flightList){
  item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

item=item[0]?.name
return item}else{
  return item
}
}
timeFormate(date:any){
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'hh:mma');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

}
convertToISOStringFormat(dateString:any) {
  // Remove the ' 00:00' part and then add 'Z' at the end
  const isoDateString = dateString?.replace('00.000 00:00', '00.000Z');
  return isoDateString;
}
flightlogoFilter(item:any){
  
  if(item){
     let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0]?.logo
   return flightName
 }
  }else{return item}
 }
 dateFormate(date:any){

  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
scroll(el: HTMLElement) {
  el.scrollIntoView();
}




salesDetail(invoice:any,i:any){

  this.insuranceData.invoiceData[i].boolean=true
  let request:any={
    itineraryId:invoice?.itineraryId,
    invoiceId:invoice?.id,
    docPref:invoice?.docPref,
    orderId:this.insuranceData?.uuid,
    transactionType:invoice?.transactionType ,
  }
  this.CartService
  .saledetails(request)
  .subscribe({
    next : (res:any) => {
      this.insuranceData.invoiceData[i].boolean=false

      this.toastMsgService.setMsg({msg : "Success!",msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      if(res) {
     let data=res
     
      } else {
      
      } 
    },error : (err) => {
      this.insuranceData.invoiceData[i].boolean=false

      this.toastMsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});

    }
  }
)
}
whatsApp(number:any){
  this.DialogService.open({msg : 'Send WhatsApp to this Number: '+number,title : "Confirmation",buttonType : "send"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Send") {
      let request:any={}
      if(this.WhatsAppNumber===null){
        request=null
      }else{
        request={'whatsappNumber':number}
       }
  this.CartService
  .whatsApp(this.insuranceData?.uuid,request)
  .subscribe({
    next : (res:any) => {
      
      this.WhatsAppNumber=null

      if(res) {
        let data:any
         data=res
if(data.WA===true){
  this.getSancharWhatsApp(this.cartUuid)
        this.toastMsgService.setMsg({msg : "Send WhatsApp Successfully!",msgTitle : "Success", msgType : "I"});
      }else{

        this.toastMsgService.setMsg({msg : "Failed to Send WhatsApp!",msgTitle : "Warning", msgType : "W"});

      }

     
      } else {
        this.toastMsgService.setMsg({msg : "Failed to Send WhatsApp!",msgTitle : "Warning", msgType : "W"});

      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : "Failed to Send WhatsApp!",msgTitle : "Warning", msgType : "W"});
      this.WhatsAppNumber=null
    }
  }
)}else if(response==='Change Number'){
  this.showNewWhatsApp=true

}else if(response==='Cancel'){
  this.showNewWhatsApp=false
  this.WhatsAppNumber=null
}


})
}



getBookedByUUid(id:any){

  this.UserService.getUserbyUUid(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     this.bookedBy= res?.name

      } else {
      } 
    },error : (err) => {

    }
  }
)


}


getUserByUUid(id:any){
 
  this.UserService.getUserbyUUid(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     this.clientName= res?.name

      } else {
      } 
    },error : (err) => {

    }
  }
)


}



WhatsAppNumber:any=null
showNewWhatsApp:boolean=false
SendNewNo(input:any) {
  this.showNewWhatsApp=false

  this.whatsApp(input)
}


onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}
isInputValid: boolean = false;
validateInput(){
  if (this.WhatsAppNumber.length === 10) {
    this.isInputValid = true;
  } else {
    this.isInputValid = false;
  }
}

downloadInvoiceLog(element:any){
  if(element?.invoiceLog===null){
    element.invoiceLog=''
  }
  this.downloadTextFile(element?.invoiceLog, element?.uniqueId+'.txt');
}
downloadTextFile(data: any, filename: string) {
  const blob = new Blob([JSON.stringify(data)], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.download = filename;
  anchor.href = url;
  anchor.click();

  window.URL.revokeObjectURL(url);
}
pnrData:any
refresh(){
  this.getOrder(this.cartUuid)
}
firstCallOrder(uuid:any){
  this.showCartData=true
  this.getOrder(uuid)
}
showCartData:boolean=false
 getOrder(uuid:any){
  this.CartService.getOrder(uuid)
  .subscribe({
    next : (res:any) => {
      this.showCartData=false

      if(res) {
     let data:any
     data=res
     this.insuranceData = data
    //  this.pnrData=data?.hotelBooking.selectedHotelOrder.hotel
    //  this.bookingId=this.insuranceData?.bookingId
     this.dataEntitylist()
     this.getUserByUUid(this.insuranceData?.corporate)
     this.getBookedByUUid( this.insuranceData?.createdBy)


      
     

      if(this.insuranceData && this.insuranceData.airItineraries.length!=0){
        

      const returnItem=this.insuranceData?.airItineraries[1];
      const thirdItem=this.insuranceData?.airItineraries[2];
  const fourthItem=this.insuranceData?.airItineraries[3];
      console.log(returnItem)
     if (returnItem) {
        // Object is not empty
       // console.log(returnItem)
        this.returnFlights=returnItem
        const returnLastFlight=this.returnFlights?.flightDetails?.flightDetailsList[this.returnFlights?.flightDetails?.flightDetailsList.length - 1];
        this.returnLastFlight=returnLastFlight
       // console.log('Data is not an empty object');
         
      }
      if (thirdItem) {
        // Object is not empty
       // console.log(returnItem)
        this.thirdFlights=thirdItem
        const thirdLastFlight=this.thirdFlights?.flightDetails?.flightDetailsList[this.thirdFlights?.flightDetails?.flightDetailsList.length - 1];

        this.thirdLastFlight=thirdLastFlight
       // console.log('Data is not an empty object');
      
      }
      if (fourthItem) {
        // Object is not empty
       // console.log(returnItem)
        this.fourthFlights=fourthItem
        const fourthLastFlight=this.fourthFlights?.flightDetails?.flightDetailsList[this.fourthFlights?.flightDetails?.flightDetailsList.length - 1];

        this.fourthLastFlight=fourthLastFlight
       // console.log('Data is not an empty object');
      
      }
      
      
      const item = this.insuranceData?.airItineraries[0];
    //console.log(item)
    
    this.flights=item
    
       console.log(this.flights?.flightDetails?.flightDetailsList[0].schDepartureTime)
      //this.SettingsService.decodeTransformedEmail(data.flightDetails)
      const lastFlight = this.flights?.flightDetails?.flightDetailsList[this.flights?.flightDetails?.flightDetailsList.length - 1];
       
    //console.log(lastFlight)
    this.lastflight = lastFlight
    }




      } else {
      } 
    },error : (err) => {
      this.showCartData=false


    }})
  }



  DataEntity:any=[]
  billingEntity:any
  dataEntitylist(){
    this.DataEntityService
   .listEntities(this.insuranceData?.corporate)
   .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.DataEntity=data
       let entity:any=[]
       if(this.insuranceData?.billingEntity){
       entity=this.DataEntity.filter((item:any)=>item.entityRefId===this.insuranceData?.billingEntity)
       this.billingEntity=entity[0]?.entityName
      }
        } else {
       
        } 
      },error : (err) => {

    }
    }
  )
 }


 emailId:any=null
 showNewEmail:boolean=false
 SendEmailNewNo(input:any) {
   this.showNewEmail=false
 
   this.emailSend(input)
 }


 emailSend(number:any){
  this.DialogService.open({msg : 'Send Email to this Email Id: '+number,title : "Confirmation",buttonType : "sendEmail"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Send") {
      let request:any={}
      if(this.emailId===null){
        request=null
      }else{
        request={'email':number}
       }
  this.CartService
  .emailSend(this.insuranceData?.uuid,request)
  .subscribe({
    next : (res:any) => {
      
      this.emailId=null

      if(res) {
        let data:any
         data=res
if(data.Email===true){
  this.getSancharEmailApp(this.cartUuid)

        this.toastMsgService.setMsg({msg : "Send Email Successfully!",msgTitle : "Success", msgType : "I"});
      }else{

        this.toastMsgService.setMsg({msg : "Failed to Send Email!",msgTitle : "Warning", msgType : "W"});

      }

     
      } else {
        this.toastMsgService.setMsg({msg : "Failed to Send Email!",msgTitle : "Warning", msgType : "W"});

      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : "Failed to Send Email!",msgTitle : "Warning", msgType : "W"});
      this.emailId=null
    }
  }
)}else if(response==='Change Email Id'){
  this.showNewEmail=true

}else if(response==='Cancel'){
 
  this.emailId=null
 this.showNewEmail=false
}


})
}
closedPopup() {
  this.showNewWhatsApp=false
  this.WhatsAppNumber=null

  this.emailId=null
 this.showNewEmail=false
  }
  isEmailValid: boolean = false;


validateEmailInput(email: string): boolean {
  // Regular expression for email validation
  const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
showAmend:boolean=false
amendSelect:any
amendRSelect:any
amendmentType:any
sector:any
sectorlastflight:any
pnr:any
itinerary:any
PassengerArray=[]

OpenAmend(type:any,Itineraries:any){
  //  this.PassengerArray=pnrObject
  this.itinerary=Itineraries.join()
  // this.pnr=pnr
  this.comment=''
  this.showAmend=true
  this.amendmentType=type
  // this.sector=item
  if(this.insuranceData.cartType==='M'){
    this.manualCancellation=true

  }else{
    this.manualCancellation=false

  }
  // this.sectorlastflight=lastSector
}
showRAction:boolean=false
showAction:boolean=false
showTAction:boolean=false
showFAction:boolean=false
selectedItineraries:any=[]
selectedRPnr:any=[]
selectedTPnr:any=[]
selectedFPnr:any=[]
PassengerRObject:any=[]
PassengerTObject:any=[]
PassengerFObject:any=[]
PassengerObject:any=[]

itinerarySelect(element:any){
  this.selectedItineraries=[]
  this.PassengerObject=this.insuranceData?.insuranceItineraries.filter((item:any) => item.showAction === true)
  this.insuranceData?.insuranceItineraries.filter((item:any) =>{
    if(item.showAction === true){
      this.selectedItineraries.push(item.uuid)
    }
        })
  if(element.showAction===true){
    this.showAction=true
    
   
  }else{
    // if( element.pnr.includes(this.selectedPnr.join())){
    //   this.selectedPnr= this.selectedPnr.filter((item:any)=>item!=element.pnr)
    //   this.PassengerObject=this.PassengerObject.filter((item:any)=>item.pnr!=element.pnr)
    //       }
  }
  this.showAction = !this.insuranceData?.insuranceItineraries.every((item:any) => item.showAction === false);

 if( this.insuranceData?.insuranceItineraries.every((item:any) => item.showAction === true)){
this.selectedALLItineraries=true
 }else{
  this.selectedALLItineraries=false

 }
}
selectedALLItineraries:boolean=false
itineraryAllSelect(){
  this.selectedItineraries=[]

  if(this.selectedALLItineraries===true){
    this.insuranceData?.insuranceItineraries.forEach((item:any) => {
      item.showAction = true
      if(item.showAction === true){
        this.selectedItineraries.push(item.uuid)
        this.showAction=true

      }
    })
  }else{
    this.insuranceData?.insuranceItineraries.forEach((item:any) => {
      item.showAction = false
      this.showAction=false
    })

  }
  

}

itineraryRSelect(element:any){
  this.selectedRPnr=[]
    this.PassengerRObject=this.returnFlights?.orderPassengerDetails.filter((item:any) => item.showRAction === true)
    this.returnFlights?.orderPassengerDetails.filter((item:any) =>{
      if(item.showRAction === true){
        this.selectedRPnr.push(item.pnr)
      }
          })


  if(element.showRAction===true){
    this.showRAction=true
  }else{
   
  }
  this.showRAction = !this.returnFlights?.orderPassengerDetails.every((item:any) => item.showAction === false);

  
}


itineraryTSelect(element:any){
  this.selectedTPnr=[]
  this.PassengerTObject=this.thirdFlights?.orderPassengerDetails.filter((item:any) => item.showTAction === true)
  this.thirdFlights?.orderPassengerDetails.filter((item:any) =>{
    if(item.showTAction === true){
      this.selectedTPnr.push(item.pnr)
    }
        })

  if(element.showTAction===true){
    this.showTAction=true
  }else{
   
  }
  this.showTAction = !this.thirdFlights?.orderPassengerDetails.every((item:any) => item.showAction === false);

  
}

itineraryFSelect(element:any){
  this.selectedFPnr=[]
  this.PassengerFObject=this.fourthFlights?.orderPassengerDetails.filter((item:any) => item.showFAction === true)
  this.fourthFlights?.orderPassengerDetails.filter((item:any) =>{
    if(item.showFAction === true){
      this.selectedFPnr.push(item.pnr)
    }
        })

  if(element.showFAction===true){
   
    this.showFAction=true
  }else{
    
  }
  this.showFAction = !this.fourthFlights?.orderPassengerDetails.every((item:any) => item.showAction === false);

  
}
AmendProcessDetail:any
amendAirItineraries:any
lastAmend:any
PassengerDetail:any={
  feeRules:0,
  feeMarkup:0,
  resellerCharges:0
}
onClickAmendPro(item:any){
  this.AmendProcessDetail=item
  this.PassengerDetail.resellerCharges=this.AmendProcessDetail?.amendmentCharges?.resellerCharges
  this.amendAirItineraries= this.insuranceData.insuranceItineraries.filter((item:any)=>item.bookingNumber.includes( this.AmendProcessDetail?.refId))
  // this.amendAirItineraries=this.amendAirItineraries
  // console.log(this.amendAirItineraries)
  // this.PassengerDetail= this.amendAirItineraries.orderPassengerDetails.filter((item:any)=>item.pnr===this.AmendProcessDetail?.refId)

  // this.PassengerDetail=this.PassengerDetail[0]
  this.PassengerDetail.feeRules=0
  this.PassengerDetail.feeMarkup=0
  this.PassengerDetail.feeRules=item?.amendmentCharges?.cancellationFees||0

  // this.lastAmend=this.amendAirItineraries?.flightDetails?.flightDetailsList[this.amendAirItineraries?.flightDetails?.flightDetailsList.length - 1]
  this.showAmendProcess=true
}

confirmDisabled:boolean=false
manualCancellation:boolean=false
cancel(){
  this.confirmDisabled=true
  let request:any={}
  if(this.selectedALLItineraries===true){
    request={itinerary:null}
  }else{
    request={itinerary:this.itinerary}

  }
  
request.cancellationType=this.manualCancellation?('M'):'A'
  this.CartService
  .cancelInsuranceOrder(request,this.insuranceData?.uuid)
  .subscribe({
    next : (res:any) => {
      this.itinerary=null
     this.PassengerArray=[]
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg :'Success',msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)
      this.showAction=false

      this.showAmend=false

    }
    ,error : (err) => {
      // this.cpnr=null
      // this. PassengerArray=[]

      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});

    }}
    )
}
confirmAmendment(){
  this.confirmDisabled=true
 let request:any={ 
  "orderId":this.insuranceData?.uuid,
 "String reason":this.comment,
 "amendType":"C",
 "data": {"pnr": this.pnr}}
  this.CartService
  .cancel(request)
  .subscribe({
    next : (res:any) => {
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : res?.message,msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)
       this.showAmend=false
     
    },error : (err) => {
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Amendment Request Failed",msgTitle : "Warning", msgType : "W"});

    }
  }
)
}




GetAmend(id:any){
  
   this.CartService
   .getAmendHotelData(id)
   .subscribe({
     next : (res:any) => {
       if(res) {
      let data=res
      this.amendCartList=data
      console.log(data)
       } else {
       
       } 
     },error : (err) => {
 
     }
   }
 )
 }



 totalPrice(rule:any,markup:any){
  return Number(rule)+Number(markup)
 }
 disabled:boolean=false
 amendProcess(){
  this.disabled=true
let request:any={
"cancellationCharges": {
      "cancellationFees":this.PassengerDetail.feeMarkup ,
      "resellerCharges": this.PassengerDetail.resellerCharges,
      "supplierAmdFees":this.PassengerDetail.feeRules 
}
}
  this.CartService
  .AmendHotelData(request,this.AmendProcessDetail?.uuId)
  .subscribe({
    next : (res:any) => {
      this.disabled=false
      if(res) {
        this.getOrder(this.cartUuid)
        this.GetAmend(this.cartUuid)

        this.showAmendProcess=false
        this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});

      } else {
      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : 'Failed to Amend',msgTitle : "Warning", msgType : "W"});

      this.disabled=false

    }
  }
)
}
passengerDetails(item:any){
  // console.log(item)
return item.filter((passenger:any)=>passenger.passengerType==='ADT')
}




generatePDF(invoiceLabel:any,policyNumber:any){
  this.CartService
  .downloadInsuranceCartPdf(this.insuranceData?.uuid,invoiceLabel,policyNumber)
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
       console.log(data)

     

      var fileName = "Policy_"+policyNumber + ".pdf";
var blob = data; // Assuming 'data' contains your PDF data
var file = new Blob([blob], { type: 'application/pdf' });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
a.download = fileName;

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
      } else {    
      } 
    },error : (err) => {
      console.log(err)


    }
  }
)

}
displayJSON(json:any) {
  let result:any={ ...json }
  delete result.otherData;
delete result.corporateFare;
delete result.fareDetailsPerPassengerType.miscellaneousData;
delete result.fareDetailsPerPassengerType.commercialData;
delete result.seatsAvailability;
delete result.passengerType;
delete result.baggageInfo;


//   if ("commercialData" in json && "miscellaneousData" in json && "seatsAvailability" in json && "passengerType" in json && "corporateFare" in json && "baggageInfo" in json && "otherData" in json  ) { 
//      // let container:any = document.getElementById('json-container');
//  }else{

//  }


 return JSON.stringify(result, null, 4);
}
// displayWEJSON(result:any){
//   return JSON.stringify(result, null, 4)

// }
displayWEJSON(item: any): string {

  let result:any={ ...item }
delete result.baseFare;
// delete result.finalTaxes;
delete result.taxComponentsAmount

  // Helper function to replace null with undefined
  const replaceNullWithUndefined = (obj: any): any => {
    if (obj === null) {
      return undefined;
    }
    if (Array.isArray(obj)) {
      return obj.map(replaceNullWithUndefined);
    }
    if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, replaceNullWithUndefined(value)])
      );
    }
    return obj;
  };

  // Replace null with undefined in the result object
  const modifiedResult = replaceNullWithUndefined(result);

  // Convert the modified result to a JSON string with 4-space indentation
  return JSON.stringify(modifiedResult, (key, value) => value === undefined ? undefined : value, 4);
}





 emailData:any=[]
whatsAppData:any=[]
getSancharWhatsApp(id:any){
  
  this.CartService
  .getSancharWhatsApp(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.whatsAppData=data
     console.log(data)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

getSancharEmailApp(id:any){
  
  this.CartService
  .getSancharEmailApp(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.emailData=data
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}


// transform(value: string): string {
//   if (!value) {
//     return '';
//   }

//   // Use regex to remove all instances of { } and [ ] with their contents
//   return value.replace(/\{.*?\}/g, '').replace(/\[.*?\]/g, '');
// }

downloadTags(tags:any){
  this.CartService
  .downloadTags(tags)
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
      //  console.log(data)

     

      var fileName = tags;
var blob = data; // Assuming 'data' contains your PDF data

var mimeType;
let type:any
type=tags.split('.')[1]
    switch(type) {
        case 'pdf':
            mimeType = 'application/pdf';
            break;
        case 'image':
            mimeType = 'image/*'; // Change this to 'image/jpeg' for JPEG images
            break;
        case 'excel':
            mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            break;
            case 'eml':
                mimeType = 'message/rfc822';
                break;
            case 'msg':
                mimeType = 'application/vnd.ms-outlook';
                break;
        default:
            mimeType = 'application/octet-stream'; // Fallback for unknown types
    }

var file = new Blob([blob], { type: mimeType });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
a.download = fileName;

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
      } else {    
      } 
    },error : (err) => {


    }
  }
)
}


pdfUrl:any
pdfDownloadUrl:any={
  uniqueId:'',
  url:''
}
showFinPdF:boolean=false
downloadFinBookPDF(item:any,uniqueId:any){
  this.pdfDownloadUrl={
    uniqueId:uniqueId,
    url:''
  }
  this.pdfUrl=null
  if(item){
    this.showFinPdF=true
  this.CartService.downloadFinBookPDF(item,uniqueId).subscribe({
    next: (response: Blob) => {
      console.log(response)
      const blob = new Blob([response], { type: 'application/pdf' });
      // const url = window.URL.createObjectURL(blob);
      this.pdfDownloadUrl.url=response;
      this.pdfDownloadUrl.uniqueId=uniqueId;

      const url = URL.createObjectURL(blob);
      const modifiedUrl = `${url}#view=FitH&navpanes=0&zoom=90`;

      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(modifiedUrl);
    console.log(this.pdfUrl)
      // Open PDF in a new browser tab
      // window.open(url);
  
      // Optional: Revoke the object URL after some time to free memory
      // setTimeout(() => {
      //   window.URL.revokeObjectURL(url);
      // }, 100);
      this.showFinPdF=false

    },
    error: (err) => {
      this.showFinPdF=false

    }
  });
  // .subscribe({
  //   next: (response: Blob) => {
  //     const blob = new Blob([response], { type: 'application/pdf' });
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = 'Invoice'+'_'+uniqueId?.replace('/', '-')+'.pdf';
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //     this.showFinPdF=false

  //   },
  //   error: (err) => {
  //     this.showFinPdF=false

  //   }
  // });
}
 
}

refreshCSR(id:any){
  
  this.CartService
  .CSRResult(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
      } else {
        this.getOrder(this.cartUuid)

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)

    }
  }
)
}

starArray(item:any){
  // console.log(item)

  let star=[]
  if(item){
    // console.log(item)
  for(let i=0;i<item;i++){
  star.push(i+1)
  }}

  // console.log(star)
  return star
}
calculateStayNights(firstDate: string, lastDate: string): number {
  const first = new Date(firstDate);
  const last = new Date(lastDate);

  // Calculate the difference in time
  const diffTime = last.getTime() - first.getTime();

  // Convert time difference to days
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  let totalDays:any=0
if(diffDays>1){
  totalDays= diffDays+" Night(s)"
}else{
  totalDays= diffDays+" Night"

}
  return totalDays;
}


parseCancellationPolicy (data: string) {
  const policy = [];

  const firstPeriod = data.match(/before (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);
  const secondPeriod = data.match(/From (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}) .*? till (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);
  const thirdPeriod = data.match(/After (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);

  if (firstPeriod) {
    policy.push({
      cancelOnOrAfter: `N/A (Before ${firstPeriod[1].split(' ')[0]})`,
      cancelOnOrBefore: firstPeriod[1],
      charges: '₹0.00 (Free Cancellation)'
    });
  }

  if (secondPeriod) {
    policy.push({
      cancelOnOrAfter: secondPeriod[1],
      cancelOnOrBefore: secondPeriod[2],
      charges: '100% of booking amount'
    });
  }

  if (thirdPeriod) {
    policy.push({
      cancelOnOrAfter: thirdPeriod[1],
      cancelOnOrBefore: 'Check-In',
      charges: '100% of booking amount'
    });
  }

  return policy;
};
splitBookingId(item:any){
if(item){
  let bookingId=item.replace(',','\n')
  return bookingId
  
}
return ''
}

display: boolean = false;

bookingId: string = '';
guestName: string = '';
guestContact: string = '';
guestConfirmationDate:any
showPopup(item:any) {
  this.display = true;
  this.bookingId=item?.bookingId||''
  this.guestName=item?.contactPerson||''
  this.guestContact=item?.contactNumber||''
  this.verifyHotelDetails.verifiedByStaff=item?.verifiedByStaff||false
  this.verifyHotelDetails.hotelPrePayment=item?.hotelPrePayment||false
  this.verifyHotelDetails.extraBedding=item?.extraBedding||false
  this.guestConfirmationDate=new Date()

}
miscellaneousRequest:any={
  specialRequest:'',
  specialRequestId:''

}
serviceControl = new FormControl();
selectedServices:any = [];
disabledMiscellaneous:boolean=false
onShowMiscellaneous(id:any,itineraryId:any,passenger:any){
  this.serviceControl = new FormControl();
  this.selectedServices=[]
    let request:any={
      itineraryId:itineraryId,
      orderId:id,
      orderPassengerDetails:passenger,
      specialRequest:'',
      specialRequestId:''
    }
    console.log(passenger)
    this.miscellaneousRequest=request

  this.showPopUp = true; // Display popup on multi-select change

}
cancelPopup(){
  this.display = false;

}
verifyHotelDetails:any={
  verifiedByStaff:false,
  hotelPrePayment:false,
  extraBedding:false
}
updateBooking() {
  // Logic to update booking details goes here
  // console.log('Booking ID:', this.bookingId);
  // console.log('Guest Name:', this.guestName);
  // console.log('Guest Contact Number:', this.guestContact);

  // Close the popup after updating

 let request:any={
  orderId:this.cartUuid,
  hotelBookingRequest:{
  hotelConfirmation:{
    bookingId: this.bookingId,
    contactPerson:this.guestName,
    contactNumber:this.guestContact,
    verifiedByStaff:this.verifyHotelDetails.verifiedByStaff,
    hotelPrePayment:this.verifyHotelDetails.hotelPrePayment,
    extraBedding:this.verifyHotelDetails.extraBedding,
    confirmationDate:this.guestConfirmationDate
  }}
 }
  this.CartService
  .UpdateHotelCart(request)
  .subscribe({
    next : (res:any) => {
      this.display = false;

      if(res) {
        this.getOrder(this.cartUuid)

     this.toastMsgService.setMsg({msg :"Booking Detail Updated Successfully",msgTitle : "Success", msgType : "I"});

      } else {
        this.toastMsgService.setMsg({msg :"Failed to Update",msgTitle : "Warning", msgType : "W"});

      } 
    },error : (err) => {

      this.toastMsgService.setMsg({msg :"Failed to Update",msgTitle : "Warning", msgType : "W"});

    }
  }
)



}


cancellationType(value:any,type:any){

  if(type==='PBA'){
    const percentageValue = this.convertToPercentage(value);
    return percentageValue
   }else if(type==='NR'){
    const rupeeValue = this.convertToRupees(value);

   return rupeeValue
   }else{
    return ''
   }
}
convertToPercentage(value: string): string {
  const numberValue = parseFloat(value);
  if(numberValue===0){
return '₹0.00 (Free Cancellation)'
  }else{
  return `${numberValue}% of booking amount`;}
}
convertToRupees(value: string): string {
  const numberValue = parseFloat(value);
  return `₹${numberValue.toFixed(2)} per room per Night`;
}
cancellationFilter(item:any){
  const parts = item.split('.');
  let cancellationPolicies = parts.filter((part:any) => part.trim() !== '');
  return cancellationPolicies
}

disabledHcn(){
  if(this.bookingId&&this.guestName&&this.guestContact&&this.verifyHotelDetails.verifiedByStaff){
    return false
  }
  return true
}
mmtBaseFare(base:any,couponDiscount:any,hotelDiscount:any){
  let data:any=(base?(base):0)-(couponDiscount?(couponDiscount):0)-(hotelDiscount?(hotelDiscount):0)
return data
}

dateFormateTime(date:any){
  const parsedDate = new Date(date);
  // console.log(parsedDate)
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'dd-MM-yyyy hh:mm:ssa');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
specialArray(item:any){
  let data:any=[]
  if(item){
    data=item?.split(',')
  }
return data
}

showPopUp:boolean=false
closeMiscellaneous() {
 
  this.showPopUp = false; // Close the popup after saving
}
serviceData = [
  { number: 'Special Request', code: 'specialRequest', type: 'Special Request' },
  // { number: 'Meal Code', Code: 'mealCode', type: 'Meal' },
  // { number: 'Baggage Weight', Code: 'Baggage Weight', type: 'Extra Baggage' },
  // { number: 'SSRCode', Code: 'SSR Description', type: 'Special SSR' },

  // { number: 'FastForward Code', Code: 'fastForwardDescription', type: 'Fast Forward' }
];



updateMiscellaneous(){
  this.disabledMiscellaneous=true
    this.CartService
    .MiscellaneousItinerary(this.miscellaneousRequest)
    .subscribe({
      next : (res:any) => {
        this.disabledMiscellaneous=false
  
        this.getOrder(this.cartUuid)
        this.showPopUp = false; 
              this.toastMsgService.setMsg({msg : "Miscellaneous Data Updated Successfully!",msgTitle : "Success", msgType : "I"});
  
        if(res) {
       let data=res
        } else {
  
        } 
      },error : (err) => {
        this.disabledMiscellaneous=false
  
        this.getOrder(this.cartUuid)
        this.toastMsgService.setMsg({msg : "Failed to Update Miscellaneous Data",msgTitle : "Warning", msgType : "W"});
  
      }
    }
  )
  }
  onMultiSelect() {
    this.selectedServices = this.serviceControl.value;

}
}
